import { DAYS } from './constants';
import { FormSection } from '../../components/ui/FormSection';
import type { OperatingHours } from './constants';

interface OperatingHoursSectionProps {
  operatingHours: OperatingHours;
  onOperatingHoursChange: (
    day: string,
    field: 'open' | 'close' | 'closed',
    value: string | boolean
  ) => void;
  operatingHoursNotes: string;
  onOperatingHoursNotesChange: (value: string) => void;
}

export const OperatingHoursSection = ({
  operatingHours,
  onOperatingHoursChange,
  operatingHoursNotes,
  onOperatingHoursNotesChange,
}: OperatingHoursSectionProps) => (
  <FormSection title="Operating Hours">
    <div className="space-y-3">
      {DAYS.map((day) => (
        <div key={day} className="flex items-center gap-4">
          <div className="w-28">
            <span className="text-sm font-medium text-gray-700 capitalize">{day}</span>
          </div>
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={!operatingHours[day].closed}
              onChange={(e) => onOperatingHoursChange(day, 'closed', !e.target.checked)}
              className="h-4 w-4"
            />
            <span className="text-sm text-gray-600">Open</span>
          </div>
          {!operatingHours[day].closed && (
            <>
              <input
                type="time"
                value={operatingHours[day].open || '10:00'}
                onChange={(e) => onOperatingHoursChange(day, 'open', e.target.value)}
                className="px-3 py-1 border border-gray-300 rounded-md text-sm"
              />
              <span className="text-gray-500">to</span>
              <input
                type="time"
                value={operatingHours[day].close || '17:00'}
                onChange={(e) => onOperatingHoursChange(day, 'close', e.target.value)}
                className="px-3 py-1 border border-gray-300 rounded-md text-sm"
              />
            </>
          )}
          {operatingHours[day].closed && <span className="text-sm text-gray-500">Closed</span>}
        </div>
      ))}
    </div>
    <div className="mt-4">
      <label htmlFor="operatingHoursNotes" className="block text-sm font-medium text-gray-700 mb-1">
        Operating Hours Notes
      </label>
      <textarea
        id="operatingHoursNotes"
        value={operatingHoursNotes}
        onChange={(e) => onOperatingHoursNotesChange(e.target.value)}
        rows={2}
        className="w-full px-3 py-2 border border-gray-300 rounded-md"
        placeholder="e.g., Closed on major holidays"
      />
    </div>
  </FormSection>
);
